// extracted by mini-css-extract-plugin
export default {"social":"socialLinks_social__iSLkh"};